export type MessengerDeliveryStatus =
  | "not_applicable"
  | "identity_pending"
  | "pending"
  | "sent"
  | "failed";

type MessengerDeliveryStatusPresentation = {
  variant: "default" | "destructive" | "secondary" | "outline";
  label: string;
  recoveryHint?: string;
};

export function getMessengerDeliveryStatusPresentation(input: {
  status: MessengerDeliveryStatus;
  errorCode?: string | null;
}): MessengerDeliveryStatusPresentation {
  if (input.status === "identity_pending") {
    return { variant: "outline", label: "ລໍຖ້າເຊື່ອມລູກຄ້າ" };
  }
  if (input.status === "sent") {
    return { variant: "default", label: "ສົ່ງ Messenger ແລ້ວ" };
  }
  if (input.status === "pending") {
    return { variant: "secondary", label: "ລໍຖ້າສົ່ງ Messenger" };
  }
  if (input.status === "failed" && input.errorCode === "FB_10900") {
    return {
      variant: "destructive",
      label: "ຄອມເມັນນີ້ເຄີຍຕອບສ່ວນຕົວແລ້ວ",
      recoveryHint: "ໃຫ້ລູກຄ້າທັກ Page ແລ້ວລະບົບຈະສົ່ງໃໝ່ອັດຕະໂນມັດ",
    };
  }
  if (input.status === "failed" && input.errorCode === "FB_10903") {
    return {
      variant: "destructive",
      label: "ໃຫ້ລູກຄ້າທັກ Page ກ່ອນ",
      recoveryHint: "ລະບົບຈະສົ່ງໃໝ່ອັດຕະໂນມັດ ເມື່ອລູກຄ້າທັກ Page",
    };
  }
  if (input.status === "failed" && input.errorCode === "FB_100") {
    return {
      variant: "destructive",
      label: "ຄອມເມັນນີ້ໃຊ້ຕອບສ່ວນຕົວບໍ່ໄດ້",
      recoveryHint: "ໃຫ້ລູກຄ້າທັກ Page ແລ້ວລະບົບຈະສົ່ງໃໝ່ອັດຕະໂນມັດ",
    };
  }
  return { variant: "destructive", label: "ສົ່ງ Messenger ບໍ່ສຳເລັດ" };
}
